export default "__VITE_ASSET__ChPAz7bB__"